<template>
  <div class="mx-4 mt-6 mb-8 white" style="width: 100vw">
    <div class="px-2 py-4 d-flex">
      <div class="mr-4">
        <v-img max-width="45px" src="/assets/images/vt_logo.png" />
      </div>
      <div class="title">Device Coverage</div>
      <!-- <v-spacer></v-spacer>
      <div class="mx-3">
        <v-btn small outlined color="primary" @click="copyURLCode()">
          Copy URL
        </v-btn>
      </div> -->
    </div>
    <div class="px-3 py-2">
      <div>
        <PrimaryFiltersVT
          :list_filters="page_content.tabs"
          @filter_update="update_current_tab($event)"
          :current_tab="current_tab"
        ></PrimaryFiltersVT>
      </div>
      <!-- <div class="px-4 mb-4" v-if="current_tab == 'Serial Number'">
        <v-text-field
          small
          style="width: 200px"
          label="Serial Number"
          v-model="deviceID"
        ></v-text-field>
        <v-btn dark small color="vtblue" @click="check_coverage(deviceID)">
          Check Coverage
        </v-btn>
      </div> -->
      <div class="px-4 mb-4" v-if="current_tab == 'SerialNumber'">
        <v-text-field small label="Serial Number" style="width: 200px" v-model="transformerNo"></v-text-field>
        <v-btn dark small color="vtblue" @click="get_deviceID"> Check Coverage </v-btn>
      </div>
      <div class="px-4 mt-6 mb-4 text-subtitle">
        <div class="mb-4 mt-2 font-weight-bold" v-if="coverage_data">
          Device ID<span class="font-weight-regular">:{{ deviceID }} {{ transformer_device_id }}</span>
        </div>
        <div class="mb-5" v-if="status">
          <v-banner max-width="400" elevation="2" sticky>
            <span class="font-weight-bold">Status: </span>{{ status }}</v-banner
          >
        </div>
        <div v-if="coverage_data" class="primary--text font-weight-bold mb-2">Messages</div>
        <div class="mx-auto">
          <DataTableVT
            v-if="coverage_data"
            :headers="page_content.coverage_table"
            :items_list="coverage_data"
            no_pagination="true"
            print="true"
            item_key="seq_num"
            no_export="true"
          />
          <v-img class="mt-2" v-if="coverage_data" max-width="300px" src="/assets/images/coverage_stats.png" />
        </div>
      </div>
    </div>
    <v-overlay class="layering" :value="dialog">
      <v-card
        :light="!this.$vuetify.theme.dark"
        class="backgroundWhite"
        style="max-width: 80vw; max-height: 40vh; overflow: auto"
      >
        <div class="close-btn">
          <v-btn right @click="closeDialog" color="backgroundWhite" elevation="0" x-small>
            <v-icon small color="primaryGrey">mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="pa-4" style="overflow: auto; height: 100%">
          <v-row class="mx-3 py-4" no-gutters>
            <v-col cols="12" no-gutters>
              {{ message }}
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import DataTableVT from "../components/DataTableVT";
import PrimaryFiltersVT from "../components/PrimaryFiltersVT";
import { content } from "../../config/device_coverage.js";

const api_root = process.env["VUE_APP_ROOT_API"];
const tenant_key = process.env["VUE_APP_TENANT_KEY"];

export default {
  name: "CoverageChecker",
  components: { DataTableVT, PrimaryFiltersVT },
  created() {
    this.page_content = content;
  },
  mounted() {},
  data: () => ({
    page_content: null,
    coverage_data: null,
    deviceID: "",
    dialog: false,
    current_tab: "SerialNumber",
    transformer_device_id: "",
    transformerNo: "",
    message: "",
  }),
  methods: {
    closeDialog() {
      this.dialog = false;
      this.deviceId = null;
    },
    update_current_tab(val) {
      this.current_tab = val;
      this.coverage_data = null;
      this.transformer_device_id = "";
      this.transformerNo = "";
      this.deviceID = "";
    },
    copyURLCode() {
      var self = this;
      this.$copyText(`${window.location.href}`).then(
        function () {
          self.message = "URL Copied Successfully!";
          self.dialog = true;
        },
        function (e) {
          self.message = "Error Copying! Please Try Again";
          self.dialog = true;
          console.log(e);
        }
      );
    },
    async check_coverage(deviceID) {
      this.network_error = false;
      const accessToken = await this.$auth.getTokenSilently();
      const tenant = (this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      var self = this;
      let headers = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      //this.$store.commit("show_loader");
      axios
        .get(api_root + `/api/checkcoverage/${deviceID}`, headers)
        .then((response) => {
          self.coverage_data = response.data;
          //self.$store.commit("hide_loader");
        })
        .catch((e) => {
          self.network_error = true;
          self.error_message = e.response;
          console.log(e);
          //self.$store.commit("hide_loader");
        });
    },
    async get_deviceID() {
      const tenant = (this.$auth.user[tenant_key] && this.$auth.user[tenant_key]["tenant"]) || "";
      this.network_error = false;
      const accessToken = await this.$auth.getTokenSilently();
      var self = this;
      //this.$store.commit("show_loader");
      let headers = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Tenant: tenant,
        },
      };
      axios
        .get(api_root + `/api/checkcoverage/deviceid/${this.transformerNo}`, headers)
        .then((response) => {
          self.transformer_device_id = response.data;
          self.check_coverage(self.transformer_device_id);
          //self.$store.commit("hide_loader");
        })
        .catch((e) => {
          self.network_error = true;
          self.error_message = e.response;
          console.log(e);
          //self.$store.commit("hide_loader");
        });
    },
  },
  computed: {
    status: function () {
      let status = null;
      let lqi = 0;
      if (this.coverage_data && this.coverage_data.length > 0) {
        this.coverage_data.map((elem) => {
          lqi = elem["lqi"].toLowerCase() == "limit" ? lqi + 1 : lqi;
        });
        status =
          lqi / this.coverage_data.length <= 0.5
            ? "Proceed with Installation using Sigfox device"
            : "Call VT technician on (01) 532 8958";
      }
      if (this.coverage_data && this.coverage_data.length == 0) {
        status = "Call VT technician on (01) 532 8958";
      }
      return status;
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

.close-btn {
  position: absolute;
  top: -0.7rem;
  right: 0;
  z-index: 9;
  padding: 1em 0;
}
</style>
